import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, Input, Tooltip, Checkbox, } from 'antd';
import { useI18n, LangSelect, useSession, } from '@newtontechnologies/applib-frontend';
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import getBlobDuration from 'get-blob-duration';
import FileSplitterUpload from './FileSplitterUpload';
import './style.less';
import DurationMessage from './DurationMessage';
const FileSplitterForm = ({ onUploadFile, uploadDisabled }) => {
    const [form] = Form.useForm();
    const [duration, setDuration] = useState('none');
    const [transcriptionLanguages, setTranscriptionLanguages] = useState([]);
    const { connection } = useSession();
    const { intl } = useI18n();
    useEffect(() => {
        const fetchTranscriptionProfiles = async () => {
            const profiles = await connection.authFetch()
                .json()
                .url(apiV2.currentUser.transcriptionProfiles.url())
                .fetch();
            const uniqueLangSet = [...new Set(profiles.map(((profile) => profile.lang)))];
            setTranscriptionLanguages(uniqueLangSet);
        };
        void fetchTranscriptionProfiles();
    }, []);
    const handleUploading = () => {
        const title = form.getFieldValue('title');
        const minutes = form.getFieldValue('minutes');
        const mediaFile = form.getFieldValue('media');
        const language = form.getFieldValue('language');
        const withVAD = form.getFieldValue('withVAD');
        onUploadFile({
            title: title !== null && title !== void 0 ? title : mediaFile.name,
            minutes: Number(minutes),
            mediaFile,
            language,
            withVAD,
        });
        localStorage.setItem('lang_splitter', language);
        form.resetFields(['media', 'title', 'minutes']);
        setDuration('none');
    };
    const handleMediaSelected = async (mediaFile) => {
        if (mediaFile !== null) {
            try {
                const durationInSeconds = await getBlobDuration(mediaFile);
                setDuration(Math.ceil(durationInSeconds / 60));
            }
            catch (error) {
                setDuration('unknown');
            }
            form.setFieldsValue({ media: mediaFile, title: mediaFile.name });
        }
        else {
            setDuration('none');
            form.setFieldsValue({ media: '', title: '', minutes: '' });
        }
    };
    return (_jsxs(Card, { className: "upload-form", children: [_jsx("div", { className: "upload-form__label", children: intl.formatMessage({ id: 'chooseSplittableFiles' }) }), _jsxs(Form, { form: form, onFinish: () => handleUploading(), initialValues: {
                    minutes: 60,
                    language: localStorage.getItem('lang_splitter') !== null ? localStorage.getItem('lang_splitter') : intl.locale,
                    withVAD: true,
                }, children: [_jsx(Form.Item, { name: "media", valuePropName: "file", rules: [
                            {
                                required: true,
                                message: intl.formatMessage({ id: 'requiredField' }),
                            },
                            {
                                validator: async (_, value) => {
                                    if (value === undefined || value === null) {
                                        return Promise.reject();
                                    }
                                    if ((Boolean(value.type.startsWith('audio'))) || (Boolean(value.type.startsWith('video')))) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(intl.formatMessage({ id: 'mediaFileUnsupported' }));
                                },
                            },
                        ], children: _jsx(FileSplitterUpload, { accept: "video/*,audio/*,.flv", onChange: (mediaFile) => handleMediaSelected(mediaFile) }) }), _jsxs("div", { className: "upload-form__inputs", children: [_jsx(DurationMessage, { duration: duration }), _jsxs(Row, { gutter: 10, children: [_jsx(Col, { span: 12, children: _jsx("p", { children: intl.formatMessage({ id: 'splitFilesDuration' }) }) }), _jsx(Col, { span: 5, children: _jsx(Form.Item, { name: "minutes", rules: [
                                                {
                                                    validator: async (_, value) => {
                                                        if (value > duration) {
                                                            return Promise.reject(intl.formatMessage({ id: 'splitLengthWarning' }));
                                                        }
                                                        return Promise.resolve();
                                                    },
                                                },
                                            ], children: _jsx(Input, { type: "number", min: "1" }) }) }), _jsx(Col, { span: 4, xs: 7, children: _jsx("p", { children: intl.formatMessage({ id: 'minutes' }) }) })] }), _jsxs(Row, { children: [_jsx(Col, { span: 12, children: _jsxs("p", { children: [intl.formatMessage({ id: 'recordingLanguage' }), ":"] }) }), _jsx(Col, { span: 12, children: _jsx(Form.Item, { name: "language", children: _jsx(LangSelect, { langs: transcriptionLanguages }) }) })] }), _jsxs(Row, { children: [_jsx(Col, { span: 12, children: _jsxs("p", { children: [intl.formatMessage({ id: 'taskName' }), ":"] }) }), _jsx(Col, { span: 12, children: _jsx(Form.Item, { name: "title", rules: [
                                                {
                                                    required: true,
                                                    whitespace: true,
                                                    message: intl.formatMessage({ id: 'requiredField' }),
                                                },
                                            ], children: _jsx(Input, { type: "text" }) }) }), _jsx(Col, { span: 24, children: _jsx(Form.Item, { name: "withVAD", valuePropName: "checked", children: _jsx(Checkbox, { children: intl.formatMessage({ id: 'voiceDetection' }) }) }) })] })] }), _jsx(Col, { className: "upload-form__controls", children: uploadDisabled ? (_jsx(Tooltip, { title: intl.formatMessage({ id: 'onlyOneFile' }), trigger: ['hover', 'click'], placement: "right", children: _jsx(Button, { htmlType: "submit", disabled: true, children: intl.formatMessage({ id: 'upload' }) }) })) : (_jsx(Button, { htmlType: "submit", children: intl.formatMessage({ id: 'upload' }) })) })] })] }));
};
export default FileSplitterForm;
